import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    const t = localStorage.getItem("medihub_token");
    if (!t) { setUser(null); return; }
    api.me().then(setUser).catch(() => {
      localStorage.removeItem("medihub_token");
      setUser(null);
    });
  }, []);

  const loginComplete = (token, u) => {
    localStorage.setItem("medihub_token", token);
    setUser(u);
  };

  const logout = async () => {
    try { await api.logout(); } catch { /* ignore */ }
    localStorage.removeItem("medihub_token");
    setUser(null);
    window.location.href = "/login";
  };

  return <AuthCtx.Provider value={{ user, loginComplete, logout }}>{children}</AuthCtx.Provider>;
}
